import React from 'react';
import { HeroSectionV5 } from '../components/HeroSectionV5';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { CommunityStories } from '../components/CommunityStories';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV5() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900 pt-[64px] md:pt-[60px]" data-id="element-656" data-mp="1gaomke2wxv3w">
      <HeroSectionV5 data-id="element-657" data-mp="3dnmtr9457kuc" />
      <PainSection data-id="element-658" data-mp="3do4uahxu8l82" />
      <TruthSection data-id="element-659" data-mp="3doed9lkgts49" />
      <ProductPresentation data-id="element-660" data-mp="3doxxj8xl8slg" />
      <ContentBreakdown data-id="element-661" data-mp="2zw87mtexv3j2" />
      <BenefitsSection data-id="element-662" data-mp="2zwzt3betnkvm" />
      <TestimonialsSection data-id="element-663" data-mp="2zxjbet8dwba6" />
      <ForYouSection data-id="element-664" data-mp="34ut026ny8iwy" />
      <GuaranteeSection data-id="element-665" data-mp="34u00bpneqtob" />
      <BonusSection data-id="element-666" data-mp="34vkrr6efdwhy" />
      <ValueStack basePrice={15.9} showFlashBonus={false} data-id="element-667" data-mp="34sow5oq1vjwo" />
      <CommunityStories data-id="element-668" data-mp="3slf5rrahdr3s" />
      <FAQSection data-id="element-669" data-mp="3skvqyjg4nitz" />
      <ImpactPhrases data-id="element-670" data-mp="3sij8842jp4fv" />
      <Footer data-id="element-671" data-mp="gb8rw8kxqnk" />
    </div>;
}